import { Button, PageHeader } from '@/components';
import { useAuth } from '@/features/auth/AuthProvider';
import { RolesTable } from '@/features/roles/RolesTable';
import { useNavigate } from '@solidjs/router';
import { Show } from 'solid-js';

export default function AdminRoles() {
  const { session } = useAuth();
  const navigate = useNavigate();

  const canCreate = () => session()?.permissions.has('roles:create') ?? false;
  const canList = () => session()?.permissions.has('roles:list') ?? false;

  return (
    <section>
      <PageHeader
        title="Roles"
        actions={
          <Show when={canCreate()}>
            <Button onClick={() => navigate('/admin/roles/new')}>New role</Button>
          </Show>
        }
      />

      <div class="mx-auto max-w-6xl p-6">
        <Show
          when={canList()}
          fallback={
            <p class="text-sm text-neutral-500">You don't have permission to view roles.</p>
          }
        >
          <RolesTable onEdit={(role) => navigate(`/admin/roles/${role.id}`)} />
        </Show>
      </div>
    </section>
  );
}
